import "../scss/__index.scss";

import "./_legacy/filters";
import "./_legacy/scripts";
import "./_legacy/bm10";

import "./components/_index";

document.addEventListener("DOMContentLoaded", () => {
  if (MicroModal) {
    document.addEventListener("mouseleave", (event) => {
      // console.log("Mouse leaving the window!");
      if (
        event.clientY <= 0 &&
        !window.sessionStorage.getItem("modalPriceStorageOpened")
      ) {
        MicroModal.show("modal_price-storage");
        window.sessionStorage.setItem("modalPriceStorageOpened", true);
      }
    });
  }
});
